import { IOnInit } from "angular";
import { UserInfo } from "../../../../../application/UserProfile";
import { GridSelectionChangedArgs } from "../../../../../records/grids/controller";
import { GridConfiguration } from "../../../../../records/views/recordGridView";
import {
  ColumnDefinitionService,
  vsName as ColumnDefinitionServiceName,
} from "../../../../../records/grids/columns/columnDefinitionService";
import { Role, RoleUser } from "../../../../model/authorityGroup";
import {
  ServerUtility,
  vsName as ServerUtilityName,
} from "../../../../../records/server/serverUtility";
import { IQuery } from "../../../../../records/server/query";

export const vsControllerAs = "roleDetailUserEditComponentController";
export class RoleDetailUserEditComponentController implements IOnInit {
  static $inject = [ColumnDefinitionServiceName, ServerUtilityName];

  // bindings
  gridConfiguration!: GridConfiguration;
  role!: Role;
  roleUsers!: RoleUser[];
  //end bindings

  private initialSelectedIds: number[] = [];
  private userRoleIds: number[] = [];
  private roleUsersOnly: boolean = true;
  private defaultQuery: IQuery = {};

  constructor(
    private readonly columnDefinitionService: ColumnDefinitionService,
    private readonly serverUtility: ServerUtility
  ) {}

  $onInit(): void {
    this.initialSelectedIds = this.roleUsers.map((ru) => ru.UserAuthId);
    this.userRoleIds = [...this.initialSelectedIds];
    this.defaultQuery = {
      Ids: this.userRoleIds,
    };
    this.gridConfiguration.columns = [
      this.columnDefinitionService.getSelectColDef(),
      ...(this.gridConfiguration.columns ?? []),
    ];
  }

  gridSelectionChanged(args: GridSelectionChangedArgs) {
    const user = <UserInfo>(<any>args.data);
    const userId = user.Id!;
    this.userRoleIds = args.gridSelection;
    if (args.selected) {
      this.defaultQuery.Ids?.push(userId);
    } else {
      if (this.defaultQuery.Ids) {
        const index = this.defaultQuery.Ids.indexOf(userId);
        this.defaultQuery.Ids.splice(index, 1);
      }
    }

    this.serverUtility.sendApiRequest<void>({
      method: args.selected ? "POST" : "DELETE",
      url: `/api/user/${user.Id}/roles`,
      data: {
        RoleId: this.role.Id,
      },
    });
  }

  roleUsersOnlyChanged(roleUserOnly: boolean) {
    this.defaultQuery.Ids = roleUserOnly ? this.userRoleIds : undefined;
  }
}
